import { createInjectionKey as o } from "./ghl-ui.es896.js";
const r = o("n-dialog-provider");
export {
  r as dialogProviderInjectionKey
};
